const errorJson = {
    enabled: true,
    billManagement: "Bill Management",
    errorLoading: "There was an error loading the bill management page.",
    signInFailed: "We could not sign you in to Bill Management.",
    signOutAndRetry: "Sign out and try again",
}

export {
    errorJson
}
